/* Casa Bellori — fiche produit (cb-fiche) */
import { CartUpdatedEvent } from '@theme/events';

var SG = {
  // [EU, UK, US, cm]
  homme: [[38,4,4.5,24],[39,5.5,6,24.5],[40,6,6.5,25],[41,6.5,7,25.5],[42,7,7.5,26],[43,8,8.5,26.5],[44,9,9.5,27],[45,9.5,10,27.5],[46,10.5,11,28],[47,11,11.5,28.5]],
  femme: [[35,2,4,22],[36,3,5,22.5],[37,4,6,23],[38,5,7,23.5],[39,6,8,24],[40,6.5,8.5,24.5],[41,7.5,9.5,25],[42,8.5,10.5,25.5]],
  enfant: [[21,4.5,5,13],[22,5,5.5,13.5],[23,6,6.5,14.3],[24,6.5,7,15],[25,7.5,8,15.6],[26,8.5,9,16.2],[27,9,9.5,16.9],[28,10,10.5,17.5],[29,11,11.5,18.1],[30,11.5,12,18.7],[31,12.5,13,19.4],[32,13,13.5,20],[33,1,1.5,20.6],[34,2,2.5,21.3],[35,2.5,3,22]]
};

function eur(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
function addBusinessDays(d, n) { var r = new Date(d); var k = 0; while (k < n) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) k++; } return r; }
function fmtLong(d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
function fmtShort(d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }).replace('.', ''); }

function toast(root, msg) {
  var t = root.querySelector('[data-cbf-toast]'); if (!t) return;
  t.textContent = msg; t.classList.add('is-visible');
  clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
}

export function cbAddToCart(items, root) {
  var drawer = document.querySelector('cart-drawer');
  var sections = ['auto-gifts'];
  if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);
  var count = items.reduce(function (a, i) { return a + i.quantity; }, 0);
  return fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items, sections: sections.join(',') })
  }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error(res.j.description || res.j.message || 'Impossible d’ajouter au panier');
      var icon = document.querySelector('cart-icon');
      var cur = icon && icon.getCurrentItemCount ? icon.getCurrentItemCount() : null;
      var newCount = cur != null ? cur + count : undefined;
      if (drawer) {
        document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: newCount, source: 'product-form', sections: res.j.sections }));
        setTimeout(function () { if (drawer.open && !(drawer.isOpen && drawer.isOpen())) { try { drawer.open(); } catch (e) {} } }, 400);
      } else {
        window.location.href = '/cart';
      }
      return res.j;
    });
}

function initFiche(root) {
  if (root.__cbf) return; root.__cbf = true;
  var variants = JSON.parse(root.querySelector('[data-cbf-variants]').textContent);
  var sizeIdx = parseInt(root.dataset.sizeIdx, 10);
  var r1 = parseFloat(root.dataset.remise1) || 0, r2 = parseFloat(root.dataset.remise2) || 0;
  var idInput = root.querySelector('[data-cbf-id]');
  var form = root.querySelector('form.cbf-form');
  var atc = root.querySelector('[data-cbf-atc]');
  var labels = root.querySelectorAll('[data-cbf-atc-label]');
  var sizesWrap = root.querySelector('[data-cbf-sizes]');
  var msg = root.querySelector('[data-cbf-msg]');
  var offer = root.querySelector('[data-cbf-offer]');

  var first = variants.find(function (v) { return v.available; }) || variants[0];
  var selected = first.options.slice();
  var sizeChosen = sizeIdx < 0;
  if (sizeIdx > -1) {
    var vals = Array.from(new Set(variants.map(function (v) { return v.options[sizeIdx]; })));
    if (vals.length === 1) { sizeChosen = true; }
  }
  var currentVariant = first;
  var mode = 1;
  var pick = null, pickVariant = null;

  /* ---------- galerie ---------- */
  var track = root.querySelector('[data-cbf-track]');
  var count = root.querySelector('[data-cbf-count]');
  var thumbs = root.querySelectorAll('[data-cbf-thumb]');
  var slides = track ? track.children.length : 0;
  function goTo(i) { if (!track) return; i = (i + slides) % slides; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
  function curIndex() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  if (track) {
    track.addEventListener('scroll', function () {
      var i = curIndex();
      if (count) count.textContent = (i + 1) + ' / ' + slides;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.cbfThumb, 10)); }); });
    var pv = root.querySelector('[data-cbf-prev]'), nx = root.querySelector('[data-cbf-next]');
    if (pv) pv.addEventListener('click', function () { goTo(curIndex() - 1); });
    if (nx) nx.addEventListener('click', function () { goTo(curIndex() + 1); });
  }
  function showVariantImage(v) {
    if (!v || !v.featured_media || !track) return;
    var src = (v.featured_media.preview_image && v.featured_media.preview_image.src) || '';
    var key = src.split('/').pop().split('?')[0].replace(/\.[a-z]+$/i, '');
    Array.from(track.querySelectorAll('img')).forEach(function (img, k) { if (key && img.src.indexOf(key) > -1) goTo(k); });
  }

  /* ---------- prix ---------- */
  function mainPrice() { return currentVariant ? currentVariant.price : first.price; }
  function refreshPrices() {
    var p = mainPrice();
    var el = root.querySelector('[data-cbf-price]'); if (el) el.textContent = eur(p);
    var p1 = p * (100 - r1) / 100;
    var e1 = root.querySelector('[data-cbf-price1]'); if (e1) e1.textContent = eur(p1);
    var o1 = root.querySelector('[data-cbf-o1]'); if (o1) o1.textContent = eur(p1);
    var o1w = root.querySelector('[data-cbf-o1-was]'); if (o1w) o1w.textContent = eur(p);
    var pp = pick ? parseFloat(pick.dataset.price) : 0;
    var tot = p + pp, tot2 = tot * (100 - r2) / 100;
    var o2 = root.querySelector('[data-cbf-o2]'); if (o2) o2.textContent = pick ? eur(tot2) : '—';
    var o2w = root.querySelector('[data-cbf-o2-was]'); if (o2w) o2w.textContent = pick ? eur(tot) : '';
    var sv = root.querySelector('[data-cbf-o2-save]'); if (sv) sv.textContent = pick ? eur(tot - tot2) : '—';
    var soldOut = currentVariant && !currentVariant.available && sizeChosen;
    var txt;
    if (soldOut) txt = 'Épuisé dans cette pointure';
    else if (mode === 2 && pick) txt = 'Ajouter les 2 paires';
    else txt = 'Ajouter au panier';
    labels.forEach(function (l) { l.textContent = txt; });
    if (atc) atc.disabled = !!soldOut;
  }

  /* ---------- variantes ---------- */
  function findVariant() {
    return variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
  }
  function update() {
    currentVariant = findVariant() || null;
    if (currentVariant && idInput) idInput.value = currentVariant.id;
    refreshPrices();
    highlightGuide();
  }
  if (sizesWrap) {
    sizesWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.cbf-size'); if (!b) return;
      if (b.classList.contains('is-out')) { toast(root, 'Cette pointure est épuisée.'); return; }
      sizesWrap.querySelectorAll('.cbf-size').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      selected[sizeIdx] = b.dataset.value; sizeChosen = true;
      var lab = root.querySelector('[data-cbf-sizelabel]'); if (lab) lab.textContent = b.dataset.value;
      sizesWrap.classList.remove('is-error'); if (msg) msg.classList.remove('is-visible');
      update();
    });
    if (sizeChosen && sizeIdx > -1) {
      var only = sizesWrap.querySelector('.cbf-size'); if (only) { only.classList.add('is-active'); var lab0 = root.querySelector('[data-cbf-sizelabel]'); if (lab0) lab0.textContent = only.dataset.value; }
    }
  }
  root.querySelectorAll('[data-cbf-opt]').forEach(function (wrap) {
    var idx = parseInt(wrap.dataset.cbfOpt, 10);
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.cbf-size'); if (!b) return;
      wrap.querySelectorAll('.cbf-size').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      selected[idx] = b.dataset.value;
      var l = root.querySelector('[data-cbf-optlabel="' + idx + '"]'); if (l) l.textContent = b.dataset.value;
      update(); showVariantImage(currentVariant);
    });
  });

  function requireSize() {
    if (sizeChosen) return true;
    if (sizesWrap) {
      sizesWrap.classList.add('is-error'); if (msg) msg.classList.add('is-visible');
      sizesWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  /* ---------- offre 1 / 2 paires ---------- */
  var pickSizes = root.querySelector('[data-cbf-picksizes]');
  var pickGrid = root.querySelector('[data-cbf-picksizegrid]');
  function renderPickSizes() {
    pickVariant = null;
    if (!pick || !pickGrid) return;
    var vs = JSON.parse(pick.dataset.variants || '[]');
    var lab = root.querySelector('[data-cbf-picklabel]'); if (lab) lab.textContent = 'à choisir';
    if (vs.length === 1) { pickVariant = vs[0]; pickSizes.classList.remove('is-visible'); return; }
    pickGrid.innerHTML = '';
    vs.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cbf-size' + (v.a ? '' : ' is-out'); b.textContent = v.s;
      b.addEventListener('click', function () {
        if (!v.a) return;
        pickGrid.querySelectorAll('.cbf-size').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        pickVariant = v; if (lab) lab.textContent = v.s; pickGrid.classList.remove('is-error');
      });
      pickGrid.appendChild(b);
    });
    pickSizes.classList.toggle('is-visible', mode === 2);
  }
  if (offer) {
    var picks = offer.querySelectorAll('[data-cbf-pick]');
    pick = picks[0] || null;
    offer.querySelectorAll('input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        mode = parseInt(r.value, 10);
        offer.classList.toggle('is-duo', mode === 2);
        offer.querySelectorAll('.cbf-opt').forEach(function (o) { o.classList.toggle('is-active', o.contains(r)); });
        if (pickSizes) pickSizes.classList.toggle('is-visible', mode === 2 && pickGrid && pickGrid.children.length > 0);
        refreshPrices();
      });
    });
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        picks.forEach(function (x) { x.classList.toggle('is-active', x === p); });
        pick = p; renderPickSizes(); refreshPrices();
      });
    });
    if (!picks.length) { var o2 = offer.querySelectorAll('.cbf-opt')[1]; if (o2) o2.style.display = 'none'; }
    renderPickSizes();
  }

  /* ---------- ajout au panier ---------- */
  function submit() {
    if (!requireSize()) return;
    if (!currentVariant) { toast(root, 'Cette combinaison n’est pas disponible.'); return; }
    var items = [{ id: currentVariant.id, quantity: 1 }];
    if (mode === 2 && pick) {
      if (!pickVariant) {
        if (pickGrid) { pickGrid.classList.add('is-error'); pickSizes.classList.add('is-visible'); pickSizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        toast(root, 'Choisissez la pointure de votre 2e paire.');
        return;
      }
      items.push({ id: pickVariant.id, quantity: 1 });
    }
    var btns = root.querySelectorAll('[data-cbf-atc],[data-cbf-sticky-btn]');
    btns.forEach(function (b) { b.classList.add('is-loading'); });
    cbAddToCart(items, root).catch(function (err) { toast(root, err.message); })
      .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  var stickyBtn = root.querySelector('[data-cbf-sticky-btn]');
  if (stickyBtn) stickyBtn.addEventListener('click', submit);
  var dyn = root.querySelector('[data-cbf-dyn]');
  if (dyn) dyn.addEventListener('click', function (e) { if (!sizeChosen) { e.preventDefault(); e.stopPropagation(); requireSize(); } }, true);

  /* ---------- barre collante ---------- */
  var sticky = root.querySelector('[data-cbf-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      var e = en[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(atc);
  }

  /* ---------- livraison ---------- */
  var now = new Date();
  var sMin = parseInt(root.dataset.shipMin, 10) || 1, sMax = parseInt(root.dataset.shipMax, 10) || 3;
  var dMin = parseInt(root.dataset.delMin, 10) || 7, dMax = parseInt(root.dataset.delMax, 10) || 12;
  var a = addBusinessDays(now, dMin), b = addBusinessDays(now, dMax);
  var set = function (sel, t) { var el = root.querySelector(sel); if (el) el.textContent = t; };
  set('[data-cbf-d1]', fmtLong(a)); set('[data-cbf-d2]', fmtLong(b));
  set('[data-cbf-s2]', fmtShort(addBusinessDays(now, sMin)) + ' – ' + fmtShort(addBusinessDays(now, sMax)));
  set('[data-cbf-s3]', fmtShort(a) + ' – ' + fmtShort(b));

  /* ---------- guide des tailles ---------- */
  var sg = root.querySelector('[data-cbf-sg]');
  var data = SG[root.dataset.genre] || SG.femme;
  if (sg) {
    var avail = sizeIdx > -1 ? variants.map(function (v) { return String(v.options[sizeIdx]); }) : [];
    var rows = data.filter(function (r) { return !avail.length || avail.indexOf(String(r[0])) > -1; });
    if (!rows.length) rows = data;
    var kid = root.dataset.genre === 'enfant';
    var h = '<p>Mesurez votre pied du talon au bout du plus long orteil, puis choisissez la pointure correspondante. Les indications propres à ce modèle sont dans l’onglet Caractéristiques.</p><table><thead><tr><th>EU</th>' + (kid ? '' : '<th>UK</th><th>US</th>') + '<th>Longueur du pied</th></tr></thead><tbody>';
    rows.forEach(function (r) { h += '<tr data-eu="' + r[0] + '"><td>' + r[0] + '</td>' + (kid ? '' : '<td>' + r[1] + '</td><td>' + r[2] + '</td>') + '<td>' + String(r[3]).replace('.', ',') + ' cm</td></tr>'; });
    sg.innerHTML = h + '</tbody></table>';
  }
  function highlightGuide() {
    if (!sg || sizeIdx < 0 || !sizeChosen) return;
    sg.querySelectorAll('tr[data-eu]').forEach(function (tr) { tr.classList.toggle('is-active', tr.dataset.eu === String(selected[sizeIdx])); });
  }
  var finder = root.querySelector('[data-cbf-findsize]');
  if (finder) finder.addEventListener('click', function () {
    var d = root.querySelector('[data-cbf-sg-details]'); if (!d) return;
    d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  update();
}

/* ---------- ajout rapide (section « Complétez ») ---------- */
function initQuick(root) {
  if (root.__cbq) return; root.__cbq = true;
  root.querySelectorAll('[data-cbf-card]').forEach(function (card) {
    var vs = JSON.parse(card.dataset.variants || '[]');
    var btn = card.querySelector('[data-cbf-quick]');
    var grid = card.querySelector('.cbf-card__sizes');
    function add(v, b) {
      if (b) b.classList.add('is-loading');
      cbAddToCart([{ id: v.id, quantity: 1 }], root).then(function () { card.classList.remove('is-open'); })
        .catch(function (err) { toast(document.querySelector('[data-cbf]') || root, err.message); })
        .finally(function () { if (b) b.classList.remove('is-loading'); });
    }
    if (!btn) return;
    btn.addEventListener('click', function () {
      var dispo = vs.filter(function (v) { return v.a; });
      if (dispo.length === 1 && vs.length === 1) { add(dispo[0], btn); return; }
      if (!grid.children.length) {
        vs.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cbf-size' + (v.a ? '' : ' is-out'); b.textContent = v.s;
          b.addEventListener('click', function () { if (v.a) add(v, b); });
          grid.appendChild(b);
        });
      }
      card.classList.toggle('is-open');
      btn.textContent = card.classList.contains('is-open') ? 'Choisissez votre pointure' : '+ Ajout rapide';
    });
  });
}

/* ---------- copier l'e-mail ---------- */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-cbf-copy]'); if (!b) return;
  var v = b.dataset.cbfCopy;
  (navigator.clipboard ? navigator.clipboard.writeText(v) : Promise.reject()).then(function () {
    var o = b.textContent; b.textContent = 'Copié'; setTimeout(function () { b.textContent = o; }, 1600);
  }).catch(function () {});
});

function boot() {
  document.querySelectorAll('[data-cbf]').forEach(initFiche);
  document.querySelectorAll('[data-cbf-more]').forEach(initQuick);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
